<template>
  <StaffLayout section="Respond Libraries" showHeader>
    <div v-if="isLoading"><Loading /></div>
    <div v-else>
      <div v-if="libraries && libraries.length > 0">
        <form
          v-on:submit.prevent
          class="w-full lg:w-1/2 pb-4 lg:pb-0 lg:float-right flex"
        >
          <input
            v-model.lazy="responseSearchString"
            placeholder="Search all libraries"
            class="flex-grow shadow appearance-none border rounded py-1 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          />
          <SearchButton @click="searchResponseContent" type="submit">
            Search
          </SearchButton>
        </form>
        <AddButton @click="addClick">Add Respond Library</AddButton>
        <div
          class="px-4 py-2 my-2 bg-gray-100 border-t cursor-pointer hover:bg-blue-200"
          v-for="lib in libraries"
          :key="lib.responseLibId"
          @click="editClick(lib)"
        >
          <!-- <router-link :to="`/staff/respondLibrary/${lib.responseLibId}`"> -->
          {{ lib.name }}
          <!-- </router-link> -->
        </div>
      </div>
      <div v-else class="mb-2">
        <span>-- No Respond Libraries found --</span>
      </div>
      <div class="mt-1">
        <AddButton @click="addClick">Add Respond Library</AddButton>
      </div>
    </div>
    <EditPopup
      entity-name="Library"
      :is-visible="isPopupVisible"
      :is-edit-mode="isEditing"
      :save-error="saveError"
      :delete-enabled="false"
      @close="isPopupVisible = false"
      @save="saveClick"
    >
      <BaseInput label="Library Name" v-model="name" type="text" :error="errors.name" />
      <BaseSelect
        v-if="!isEditing"
        label="Copy From Library"
        :options="libraryOptions"
        v-model="copySource"
      />
    </EditPopup>
  </StaffLayout>
</template>

<script setup lang="ts">
import { useRespondStore } from "../../store/respondStore";
import { ResponseLibDTO } from "../../store/generatedFetchClient";

import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { NameValue } from "../../sharedTypes";

const respondStore = useRespondStore();
const router = useRouter();

onMounted(loadData);
async function loadData() {
  isLoading.value = true;
  await respondStore.getLibraryList();
  isLoading.value = false;
}

let libraries = computed(() => respondStore.libraryList);
const libraryOptions = computed(() => {
  let options = libraries.value.map((l) => {
    return {
      name: l.name,
      value: l.responseLibId,
    } as NameValue;
  });
  return options;
});

const isLoading = ref(false);

// Popup stuff
const isPopupVisible = ref(false);
const isEditing = ref(false);
const saveError = ref("");
let selected = ref<ResponseLibDTO | null>(null);

const { handleSubmit, errors } = useForm({
  validationSchema: yup.object({
    name: yup.string().required().max(50).label("Name"),
  }),
  initialValues: {
    name: "",
  },
});

const { value: name } = useField<string>("name");
let copySource = ref<number | undefined | null>(-1);

let saveClick = handleSubmit(onValidSubmit, onInvalidSubmit);

async function onValidSubmit() {
  console.log(`Saving Library '${name.value}', copy from: ${copySource.value}`);

  let errorValue = await respondStore.SaveResponseLib({
    name: name.value,
    copySourceId: copySource.value,
  });

  if (errorValue && errorValue.length > 0) {
    saveError.value = errorValue;
  } else {
    isLoading.value = true;
    await respondStore.getLibraryList(true);
    isLoading.value = false;
    isPopupVisible.value = false;
  }
}

function onInvalidSubmit(ctx: any) {
  saveError.value = "One or more invalid form inputs.";
  console.log("error trying to submit form", ctx);
}

async function addClick() {
  isEditing.value = false;
  saveError.value = "";
  selected.value = null;
  name.value = "";
  isPopupVisible.value = true;
}

function editClick(lib: ResponseLibDTO) {
  router.push(`respondLibrary/${lib.responseLibId}`);
}

//-----------------------------------
// #region Search Response Library
//-----------------------------------

let responseSearchString = ref("");
function searchResponseContent() {
  respondStore.searchAllResponseContent(responseSearchString.value);
  router.push("/staff/respondsearchresults");
}

//-----------------------------------
// #endregion Search Respond Library
//-----------------------------------
</script>
